import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";

const FormHookInput = props => {
  const {
    defaultValue,
    className,
    style,
    errors,
    placeholder,
    showErrorText,
    inputstyle,
    type,
    label,
    step,
    disabled,
    onFocus,
    onWheel,
    register
  } = props;
  let classNames = className ? className : "form-control";
  const error = _.get(errors, register.name)
  if (error) {
    classNames += " is-invalid";
  }
  return (
    <>
      <div style={{position: 'relative', ...style}}>
        <label className={'absolutLabel'}>{label}</label>
        <input
          type={type ? type : "text"}
          style={inputstyle}
          placeholder={placeholder}
          onFocus={(e) => onFocus ? onFocus(e) : () => {
          }}
          disabled={disabled}
          onWheel={(e) => onWheel ? onWheel(e) : () => {
          }}
          defaultValue={defaultValue}
          className={classNames}
          step={(type === 'number' && step) && step}
          {...register}
        />
      </div>
      {error && showErrorText && <div className={'text-danger'}>{error.message}</div>}
    </>

  );
};
FormHookInput.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  //defaultValue: PropTypes.string,
  errors: PropTypes.object,
  className: PropTypes.string,
  ref: PropTypes.any,
  type: PropTypes.string
};

export default FormHookInput;
